import React from "react";
import loadable from "@loadable/component";

export default {
	component: loadable(() => import(/* webpackChunkName: "ContractorLogin" */ "./ContractorLogin"),{
		fallback: <div>Loading...</div>
	})
};